module.exports = __webpack_public_path__ + "static/media/finance_character.efdacec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/finance_character.png
// module id = 1106
// module chunks = 21